module.exports = __webpack_public_path__ + "static/media/laptop-login-bg.a5c9b9db.png";